export default {
    convoItems: state => state.convoItems,
    currentSessionId: state => state.currentSessionId,
    sessionHistory: state => state.sessionHistory,
    isFetchingSessionHistory: state => state.isFetchingSessionHistory
};
  